import {
    useGetPing
} from "./requests";

export const useSessionApi = () => {
    const {
        isLoading: getPingLoading,
        cancel: cancelGetPing,
         getPing
    } = useGetPing();

    return {
        getPing: {
            query: getPing,
            isLoading: getPingLoading,
            cancel: cancelGetPing
        },
}
}

